import React, {Component} from "react";
import "./Portfolio.css";

import PageSection from "PageSection/PageSection";
import Header from "Header/Header";
import Projects from "./Projects/Projects";

import text from "text";

export default class Portfolio extends Component
{
	render()
	{
		return (
			<PageSection handleRef={this.props.handleRef} className="portfolio">
				<Header title="Portfolio" />

				<p className="headerMargin" dangerouslySetInnerHTML={{__html: text.PORTFOLIO}} />

				<Projects />
			</PageSection>
		);
	}
}


// WEBPACK FOOTER //
// ./src/components/Home/Portfolio/Portfolio.js